import {
  MenuItem,
  MenuItemProps,
  Select,
  SelectProps,
  styled,
} from '@mui/material';
import { FontSizes } from 'constants/font-sizes';
import { Colors } from 'constants/colors';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface StyledSelectProps extends SelectProps {
  variant: 'standard' | 'outlined' | 'filled';
  color: 'error' | 'primary' | 'info' | 'secondary';
  size: 'small' | 'medium';
}

export const StyledSelect = styled((props: StyledSelectProps) => (
  // @ts-ignore
  <Select IconComponent={ExpandMoreIcon} {...props} />
))<{ fontSize?: string; height?: string }>(({ fontSize, height }) => ({
  //   minWidth: '80px',
  height: height ? height : '30px',
  fontSize: '14px',

  '&.MuiInputBase-sizeSmall': {
    height: '25px',
  },
  '& .MuiInputLabel-root': {
    color: `${Colors.darkGray}!important`,
  },
  '&.MuiOutlinedInput-root': {
    borderColor: `${Colors.darkGray}`,
    '& .MuiOutlinedInput-input': {
      textFillColor: `${Colors.blackPearl}`,
    },
    '& .MuiSelect-outlined': {
      color: Colors.blackPearl,
      padding: '0 6px',
      fontSize: fontSize || FontSizes.fontSize11,
      lineHeight: '25px',
    },

    '& .MuiSelect-icon': {
      color: Colors.darkGray,
      fontSize: FontSizes.fontSize14,
    },

    '&.MuiInputBase-colorSecondary': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.blackPearl,
          borderWidth: '1px',
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: Colors.darkCyan,
        borderWidth: '1px',
      },

      '&:hover': {
        borderColor: Colors.darkCyan,
        opacity: 0.8,

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.darkCyan,
          opacity: 0.8,
        },
      },
    },

    '&.MuiInputBase-colorInfo': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.sectionBorder,
          borderWidth: '1px',
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: Colors.blackPearl,
        borderWidth: '1px',
      },

      '&:hover': {
        borderColor: Colors.blackPearl,
        opacity: 0.8,

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.blackPearl,
          opacity: 0.8,
        },
      },
    },

    '&.MuiInputBase-colorPrimary': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${Colors.white}`,
          borderColor: Colors.purple,
          borderWidth: '1px',
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: Colors.purple,
        borderWidth: '1px',
      },

      '&:hover': {
        borderColor: Colors.purple,
        opacity: 0.8,

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.purple,
          opacity: 0.8,
        },
      },
    },

    '&.MuiInputBase-colorError': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.red,
          borderWidth: '1px',
          color: Colors.blackPearl,
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: Colors.red,
        borderWidth: '1px',
      },

      '&:hover': {
        borderColor: Colors.red,
        opacity: 0.8,

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: Colors.red,
          opacity: 0.8,
        },
      },
    },
  },

  '&.MuiFilledInput-root': {
    background: 'none',
    '&:hover': {
      '&:before': {
        borderBottom: 'none',
      },
      '&:after': {
        borderBottom: 'none',
      },
    },
    '&:before': {
      borderBottom: 'none',
    },
    '&:after': {
      borderBottom: 'none',
    },

    '& .MuiSelect-filled': {
      minWidth: '120px',
      padding: '8px 10px',
      fontWeight: 500,
      background: Colors.white,
      border: `1px solid ${Colors.blackPearl}`,
      borderRadius: '3px',
      color: Colors.blackPearl,

      '&.Mui-disabled': {
        border: `1px solid ${Colors.blackPearl}`,
        color: Colors.sectionBackground,
      },
    },
    '& .MuiSvgIcon-root': {
      color: Colors.blackPearl,
      width: '16px',
      height: '16px',
      top: 'calc(50% - 8px)',
    },
  },

  '&.MuiInput-underline': {
    '& .MuiSelect-standard': {
      color: Colors.blackPearl,
      padding: '0',
      fontSize: fontSize || FontSizes.fontSize10,
      lineHeight: '25px',
    },

    '&.MuiSelect-icon': {
      color: Colors.blackPearl,
      fontSize: FontSizes.fontSize14,
    },

    // '&.Mui-disabled': {
    //   opacity: 0.4,
    //   color: Colors.white,
    //   webkitTextFillColor: Colors.white,

    //   '&:before': {
    //     opacity: 0.4,
    //   },
    // },

    '&:hover': {
      opacity: 0.8,

      '&:after': {
        borderBottom: 'none',
      },
    },
    '&:after': {
      borderBottom: 'none',
    },

    '&.MuiInputBase-colorError': {
      '&:before': {
        borderBottom: `1px solid ${Colors.red}`,
      },
    },

    '&.MuiInputBase-colorInfo': {
      '&:before': {
        borderBottom: `1px solid ${Colors.white}`,
      },
    },

    '&.MuiInputBase-colorSecondary': {
      '&:before': {
        borderBottom: `1px solid ${Colors.darkCyan}`,
      },
    },

    '&.MuiInputBase-colorPrimary': {
      '&:before': {
        borderBottom: `1px solid ${Colors.purple}`,
      },
    },
  },
}));

export const StyledOptionItem = styled((props: MenuItemProps) => (
  <MenuItem {...props} />
))<{ fontSize?: string }>(({ fontSize }) => ({
  backgroundColor: Colors.white,
  fontSize: fontSize || FontSizes.fontSize11,
  color: Colors.darkGray,
  padding: '6px 16px',

  '&:hover': {
    backgroundColor: Colors.tableHeader,
    color: Colors.blackPearl,
  },

  '&.Mui-selected': {
    backgroundColor: Colors.tableHeader,
    color: Colors.blackPearl,

    '&:hover': {
      backgroundColor: Colors.tableHeader,
    },
  },
}));
